export default {"src":"/_next/static/media/logo-footer-blue.40775c6b.svg","height":64,"width":125,"blurWidth":0,"blurHeight":0};